var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFreemium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.797 69.3895H98.8954V51.686C98.8954 38.7035 88.2733 28.0814 75.2907 28.0814C62.3081 28.0814 51.6861 38.7035 51.6861 51.686V69.3895H45.7849C42.8343 69.3895 39.8837 72.3401 39.8837 75.2907V116.599C39.8837 119.549 42.8343 122.5 45.7849 122.5H104.797C107.747 122.5 110.698 119.549 110.698 116.599V75.2907C110.698 72.3401 107.747 69.3895 104.797 69.3895ZM81.1919 110.698H69.3895L71.75 97.7151C68.7994 96.5349 66.439 92.9942 66.439 90.0436C66.439 85.3227 70.5698 81.1919 75.2907 81.1919C80.0116 81.1919 84.1424 85.3227 84.1424 90.0436C84.1424 93.5843 82.3721 96.5349 78.8314 97.7151L81.1919 110.698ZM87.093 69.3895H63.4884V51.686C63.4884 45.1948 68.7994 39.8837 75.2907 39.8837C81.782 39.8837 87.093 45.1948 87.093 51.686V69.3895Z",
    fill: "#00214D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "#00214D",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFreemium);
export default __webpack_public_path__ + "static/media/icon-freemium.4cb2c089b65f7a7947005cfa0542b5a5.svg";
export { ForwardRef as ReactComponent };